// extracted by mini-css-extract-plugin
module.exports = {"banner":"ProfileUnderRevireBanner_banner__7KRFj"};